/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ voiceName: NonNullable<unknown> }} Voices_Select_Voice_Aria_LabelInputs */

const en_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Select voice ${i?.voiceName}`)
};

const fr_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selectionner la voix ${i?.voiceName}`)
};

const de_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Stimme auswählen ${i?.voiceName}`)
};

const it_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleziona la voce ${i?.voiceName}`)
};

const ru_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Выберите голос ${i?.voiceName}`)
};

const es_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Seleccionar voz ${i?.voiceName}`)
};

const zh_cn2_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`选择语音${i?.voiceName}`)
};

const ja_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`音声を選択 ${i?.voiceName}`)
};

const hi_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`वॉइस ${i?.voiceName} चुनें`)
};

const pt_pt2_voices_select_voice_aria_label = /** @type {(inputs: Voices_Select_Voice_Aria_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Selecione a voz ${i?.voiceName}`)
};

/**
* | output |
* | --- |
* | "Select voice {voiceName}" |
*
* @param {Voices_Select_Voice_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_select_voice_aria_label = /** @type {((inputs: Voices_Select_Voice_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Select_Voice_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voices_select_voice_aria_label(inputs)
	if (locale === "de") return de_voices_select_voice_aria_label(inputs)
	if (locale === "it") return it_voices_select_voice_aria_label(inputs)
	if (locale === "ru") return ru_voices_select_voice_aria_label(inputs)
	if (locale === "es") return es_voices_select_voice_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_voices_select_voice_aria_label(inputs)
	if (locale === "ja") return ja_voices_select_voice_aria_label(inputs)
	if (locale === "hi") return hi_voices_select_voice_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_voices_select_voice_aria_label(inputs)
	return en_voices_select_voice_aria_label(inputs)
});